import { QueryKey } from '@tanstack/query-core';

export const audienceQueryKeys: QueryKey = ['service', 'audience', 'support'] as const;
export const audienceRetrieveQueryKeys: QueryKey = ['retrieve'] as const;
export const issueKeys: QueryKey = [...audienceQueryKeys, 'query', 'issues'] as const;
export const issueAttachmentKeys: QueryKey = [...audienceQueryKeys, 'query', 'issue_attachment'] as const;
export const requestsAttachmentKeys: QueryKey = [...audienceQueryKeys, 'query', 'requests_attachment'] as const;
export const requestsKeys: QueryKey = [...audienceQueryKeys, 'query', 'supportRequests'] as const;
